module.exports = __webpack_public_path__ + "img/logo-primary.10ddd28a.png";